import { styledSafe } from "src/utils/styledComponent";

const ImageElement = styledSafe("img")``;

interface Props {
  src: string;
}

export const Image = ({ src }: Props) => <ImageElement src={src} />;
